import { RadioGroupField as BaseRadioGroupField } from '@wyz/ui';
import * as React from 'react';

import { useI18n } from '~/common/context';

type RadioGroupFieldProps = React.ComponentProps<typeof BaseRadioGroupField>;
function RadioGroupField(props: Omit<RadioGroupFieldProps, 'translate'>) {
  const { t } = useI18n();

  return <BaseRadioGroupField {...props} translate={t} />;
}

export default RadioGroupField;
